import api, { $ } from "kw/api";

import { deref } from "kanopi-components/utils/primitives";

type TusePasswordResetConfirmArgs = {
  token?: string;
  newPassword1?: string;
  newPassword2?: string;
};

export function usePasswordResetConfirm({
  token,
  newPassword1,
  newPassword2,
}: TusePasswordResetConfirmArgs = {}) {
  const submitPasswordResetConfirm = async (overrides = {}) => {
    const {
      passwordReset: { errors },
    } = await passwordResetConfirmMutation({
      token: deref(overrides, "token", token),
      newPassword1: deref(overrides, "password1", newPassword1),
      newPassword2: deref(overrides, "password2", newPassword2),
    });

    if (errors) {
      const error = errors.nonFieldErrors?.map((error) => error.message);
      throw new Error(error || "Something went wrong! We've notified the team.");
    }
  };

  return submitPasswordResetConfirm;
}

export async function passwordResetConfirmMutation({
  token,
  newPassword1,
  newPassword2,
}) {
  return api.mutation(
    {
      passwordReset: [
        {
          token: $("token", "String!"),
          newPassword1: $("newPassword1", "String!"),
          newPassword2: $("newPassword2", "String!"),
        },
        {
          errors: true,
        },
      ],
    },
    {
      token,
      newPassword1,
      newPassword2,
    }
  );
}
